import styled from 'styled-components'
import { ScoreDisplay } from '../atoms/ScoreDisplay/ScoreDisplay'

export const HeaderContainer = styled.div`
  margin-bottom: 32px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

export const HeaderContent = styled.div`
  flex: 1;
`

export const PageTitle = styled.h1`
  font-size: 28px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0 0 8px 0;
  letter-spacing: -0.5px;
`

export const PageSubtitle = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0;
`

export const ScoreDisplayWrapper = styled(ScoreDisplay)<{ $variant?: string }>`
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: 12px;
  padding: 16px 20px;
  box-shadow: ${({ theme }) => theme.shadows.sm};
`
